/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/nlp-integration-api-client";
import type { GetLiveTopicsTopicByIdQueryResponse, GetLiveTopicsTopicByIdPathParams } from "../models/GetLiveTopicsTopicById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLiveTopicsTopicById } from "../axios/getLiveTopicsTopicById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLiveTopicsTopicByIdQueryKey = (slug: GetLiveTopicsTopicByIdPathParams["slug"], topicId: GetLiveTopicsTopicByIdPathParams["topicId"]) => ["nlp-integration-api", { url: '/live-topics/:slug/topics/:topicId', params: {slug:slug,topicId:topicId} }] as const

export type GetLiveTopicsTopicByIdQueryKey = ReturnType<typeof getLiveTopicsTopicByIdQueryKey>

export function getLiveTopicsTopicByIdQueryOptions(slug: GetLiveTopicsTopicByIdPathParams["slug"], topicId: GetLiveTopicsTopicByIdPathParams["topicId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLiveTopicsTopicByIdQueryKey(slug, topicId)
        return queryOptions<GetLiveTopicsTopicByIdQueryResponse, ResponseErrorConfig<Error>, GetLiveTopicsTopicByIdQueryResponse, typeof queryKey>({
         enabled: !!(slug&& topicId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLiveTopicsTopicById(slug, topicId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Fetch a single topic by id for the given channel slug.
 * @summary Get topic by id
 * {@link /live-topics/:slug/topics/:topicId}
 */
export function useGetLiveTopicsTopicById<TData = GetLiveTopicsTopicByIdQueryResponse, TQueryData = GetLiveTopicsTopicByIdQueryResponse, TQueryKey extends QueryKey = GetLiveTopicsTopicByIdQueryKey>(slug: GetLiveTopicsTopicByIdPathParams["slug"], topicId: GetLiveTopicsTopicByIdPathParams["topicId"], options: 
{
  query?: Partial<QueryObserverOptions<GetLiveTopicsTopicByIdQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getLiveTopicsTopicByIdQueryKey(slug, topicId)
         

         const query = useQuery({
          ...getLiveTopicsTopicByIdQueryOptions(slug, topicId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}